import { useState, useEffect } from 'react'

export const usePhysicalActivity = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [physicalActivitiesOptions, setPhysicalActivitiesOptions] = useState([])

  useEffect(() => {
    fetchPhysicalActivities()
  }, [])

  const fetchPhysicalActivities = async () => {
    setIsLoading(true)

    try {
      // In production, this would be an API call to fetch physical activities
      // For now, we'll use mock data
      const options = [
        { value: 'walking', label: 'Walking' },
        { value: 'jogging', label: 'Jogging' },
        { value: 'running', label: 'Running' },
        { value: 'cycling', label: 'Cycling' },
        { value: 'swimming', label: 'Swimming' },
        { value: 'yoga', label: 'Yoga' },
        { value: 'pilates', label: 'Pilates' },
        { value: 'strength-training', label: 'Strength Training' },
        { value: 'weight-lifting', label: 'Weight Lifting' },
        { value: 'hiit', label: 'High-Intensity Interval Training (HIIT)' },
        { value: 'stretching', label: 'Stretching' },
        { value: 'tai-chi', label: 'Tai Chi' },
        { value: 'dancing', label: 'Dancing' },
        { value: 'aerobics', label: 'Aerobics' },
        { value: 'rowing', label: 'Rowing' },
        { value: 'stair-climbing', label: 'Stair Climbing' },
        { value: 'elliptical-trainer', label: 'Elliptical Trainer' },
        { value: 'tennis', label: 'Tennis' },
        { value: 'basketball', label: 'Basketball' },
        { value: 'soccer', label: 'Soccer' },
        { value: 'golf', label: 'Golf' },
        { value: 'functional-training', label: 'Functional Training' },
        { value: 'balance-exercises', label: 'Balance Exercises' },
        { value: 'boxing', label: 'Boxing' },
        { value: 'meditation', label: 'Meditation (Mind-Body)' }
      ]

      setPhysicalActivitiesOptions(options)
    } catch (error) {
      console.error('Error fetching physical activities', error)
    }

    setIsLoading(false)
  }

  const addCustomActivity = (customOption) => {
    if (!customOption || !customOption.value || !customOption.label) return

    // Check if the option already exists
    const exists = physicalActivitiesOptions.some((option) => option.value === customOption.value)
    if (exists) return

    setPhysicalActivitiesOptions([...physicalActivitiesOptions, customOption])
  }

  const scheduleActivity = (activity) => {
    // In production, this would make an API call to schedule the activity
    // Implementation would depend on your backend architecture
  }

  const trackActivityProgress = (activityId, progressData) => {
    // In production, this would make an API call to track progress
    // Implementation would depend on your backend architecture
  }

  return {
    isLoading,
    physicalActivitiesOptions,
    fetchPhysicalActivities,
    addCustomActivity,
    scheduleActivity,
    trackActivityProgress
  }
}
